// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MenuBar_wrap_fqfrv","items":"MenuBar_items_1tw65","isActive":"MenuBar_isActive_3a2KX"};